/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { colors, font, layouts } from '../config/theme';
import {
  widthHeight100,
  flexCenter,
  flexRowSpaceBetween,
  flexColSpaceBetween,
  pointer
} from '../utils/jss-utils';

const style = {
  'input, select, textarea': {
    fontWeight: '100',
    '@media only screen and (max-width: 1009px)': {
      fontSize: '15px'
    },
    '@media only screen and (min-width: 1010px)': {
      fontSize: '16px'
    },
    '&:focus': {
      outline: 'none'
    }
  },
  'div, span, ul, li, img': {
    '&:focus': {
      outline: 'none'
    }
  },
  // 'input[type="radio"], label': {
  //   ...pointer,
  //   fontWeight: '400'
  // },
  'input[type="text"]': {
    '-webkit-appearance': 'none'
  },
  'input[type="file"], input[type="checkbox"], input[type="radio"], select': {
    margin: 0
  },
  '.marginUnder': {
    marginBottom: '5px !important'
  },
  '.underlineText': {
    transition: 'border .3s !important',
    border: `1px solid ${colors.lightGray} !important`,
    borderTop: 'none !important',
    borderLeft: 'none !important',
    borderRight: 'none !important',
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    height: '52px !important',
    fontSize: '26px !important',
    fontWeight: 'light !important',
    width: '100% !important',
    margin: '0 !important',
    marginTop: '8px !important',
    borderRadius: '0px !important',
    padding: '0 !important',
    '&:focus': {
      border: `1px solid ${colors.black} !important`,
      borderTop: 'none !important',
      borderLeft: 'none !important',
      borderRight: 'none !important'
    }
  },
  a: {
    textDecoration: 'none',
    color: colors.blue,
    transition: 'all .2s',
    '&:hover': {
      opacity: '.8'
    }
  },
  li: {
    listStyleType: 'none',
    listStyle: 'none'
  },
  'h1, h2': {
    margin: '0px 0 30px 0',
    '@media only screen and (max-width: 1009px)': {
      margin: '0px 0 25px 0'
    }
  },
  h3: {
    margin: '0 0 20px 0',
    '@media only screen and (max-width: 1009px)': {
      margin: '0 0 10px 0'
    }
  },
  'h1, h2, h3, h4, h5, h6, h7': {
    // fontWeight: font.weights.light
  },
  h2: {
    marginBottom: '25px !important',
    '@media only screen and (max-width: 1009px)': {
      paddingTop: '25px !important'
    }
  },
  h5: {
    fontSize: `${font.sizes.small} !important`
  },
  '.titleImg': {
    height: '60px',
    marginBottom: '35px',
    '& svg': {
      height: '60px'
    },
    '@media only screen and (min-width: 1010px)': {
      marginTop: '10px'
    },
    '@media only screen and (max-width: 1009px)': {
      height: '55px',
      marginBottom: '15px',
      '& svg': {
        height: '55px'
      }
    }
  },
  '.modalImg': {
    height: '80px',
    marginBottom: '35px',
    '@media only screen and (max-width: 1009px)': {
      height: '65px',
      marginBottom: '15px'
    }
  },
  '.profileSelect': {
    marginBottom: '35px'
  },
  '.inputTitle': {
    marginBottom: '15px',
    fontSize: '14px',
    fontWeight: '500'
  },
  '.inlineCheckbox': {
    marginBottom: '10px',
    fontSize: '14px',
    '& input[type="checkbox"]': {
      marginRight: '10px'
    }
  },
  '.fullWidth': {
    minWidth: '100% !important'
  },
  '.fullWidthButton': {
    maxWidth: '100% !important',
    '@media only screen and (max-width: 1009px)': {
      marginBottom: '25px !important'
    }
  },
  '.noMarginPadding': {
    margin: '0 !important',
    padding: '0 !important'
  },
  '.inlineRadioContainer': {
    '& label': {
      display: 'inline-block',
      marginRight: '50px',
      marginBottom: '15px',
      '& input[type="radio"]': {
        marginRight: '10px'
      }
    }
  },
  '.blockRadioContainer': {
    '& label': {
      display: 'block',
      height: '32px',
      '& input[type="radio"]': {
        marginRight: '10px'
      }
    }
  },
  '.headshot': {
    borderRadius: '50%',
    border: `2px solid ${colors.lightGray}`,
    height: '150px',
    width: '150px',
    marginBottom: '20px'
  },
  '.loaderHolder': {
    '@media only screen and (max-width: 1009px)': {
      ...widthHeight100
    },
    '@media only screen and (min-width: 1010px)': {
      ...widthHeight100
    },
    ...flexCenter
  },
  '.flexRowSpaceBetween': {
    ...flexRowSpaceBetween
  },
  '.flex': {
    display: 'flex'
  },
  '.flexColSpaceBetween': {
    ...flexColSpaceBetween
  },
  '.flexCenter': {
    ...flexCenter
  },
  '.hideOnMobile': {
    '@media only screen and (max-width: 1009px)': {
      zIndex: '-2 !important',
      position: 'absolute',
      maxWidth: '100%',
      display: 'none !important'
    }
  },
  '.actionButton': {
    '@media only screen and (max-width: 1009px)': {
      maxWidth: 'calc(100% - 80px)'
    }
  },
  html: {
    '@media only screen and (min-width: 1010px)': {
      background: {
        image:
          'linear-gradient(-45deg, #f3f4ee, #a5d5d5, #e9e1d6, #a074bf, #775f99)',
        repeat: 'no-repeat'
      }
    },
    '& body': {
      margin: '0',
      padding: '0',
      height: '100%',
      '@media only screen and (min-width: 1010px)': {
        background: {
          image:
            'linear-gradient(-45deg, #f3f4ee, #a5d5d5, #e9e1d6, #a074bf, #775f99)',
          repeat: 'no-repeat'
        }
      },
      '& #root': {
        height: '100vh',
        // width: '100%',
        // maxHeight: '100%',
        // // maxHeight: '100vh',
        // maxWidth: '100vw',
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        '@media only screen and (min-width: 1010px)': {
          // padding: '30px !important'
        },
        font: {
          size: '1em',
          family: '"GT-America", Helvetica", sans-serif'
        },
        background: {
          color: colors.lighterGray
        },
        '& .app': {
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start',
          overflow: 'hidden',
          background: {
            color: colors.white
          },
          '& .sidebar': {
            width: '100%',
            height: '100%',
            display: 'flex',
            backgroundColor: colors.white,
            justifyContent: 'space-between',
            flexDirection: 'column',
            '@media only screen and (min-width: 1010px)': {
              width: '355px',
              minWidth: '355px',
              borderRight: `2px solid ${colors.lighterGray}`
              // paddingLeft: '45px',
              // paddingRight: '45px',
              // paddingTop: '10px',
              // paddingBottom: '10px'
            },
            '@media only screen and (max-width: 1009px)': {
              minWidth: '100%',
              // position: 'absolute',
              zIndex: '2',
              paddingLeft: '25px',
              paddingRight: '25px',
              height: 'calc(100% - 70px)',
              top: '70px',
              position: 'relative'
            }
          },
          '& .main': {
            width: '100%',
            // maxWidth: 'calc(100% - 60px)',
            // '@media only screen and (min-width: 1010px)': {
            //   padding: '0px 70px 0px 70px' //use content padding in theme
            // },
            '@media only screen and (min-width: 1010px)': {
              padding: '0px 60px 0px 60px' // use content padding in theme
            },
            // '@media only screen and (max-width: 1009px)': {
            //   padding: '0px 25px 0px 25px' //use content padding in theme
            // },
            '@media only screen and (max-width: 1009px)': {
              padding: '0px 0px 60px 0px' // use content padding in theme
            },
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: colors.white,
            flexWrap: 'wrap',
            alignContent: 'flex-start',
            '& .main-header': {
              height: '80px',
              width: '100%',
              backgroundColor: colors.white,
              '@media only screen and (min-width: 1010px)': {
                marginTop: '10px'
              },
              '@media only screen and (max-width: 1009px)': {
                height: layouts.desktopHeader.height,
                position: 'fixed',
                zIndex: '4',
                left: '0',
                top: '0'
              },
              '& .main-flex': {
                display: 'flex',
                justifyContent: 'flex-end',
                flexBasis: '100%',
                height: '100%'
              }
            },
            '& .main-content': {
              ...widthHeight100,
              maxWidth: '100%',
              overflowY: 'scroll !important',

              '@media only screen and (min-width: 1010px)': {
                paddingTop: '2px',
                maxHeight: 'calc(100% - 140px)'
              },
              '@media only screen and (max-width: 1009px)': {
                height: '100%',
                top: '70px',
                position: 'relative'
                // paddingBottom: '70px',
                // paddingTop: '15px'
              },
              '&::-webkit-scrollbar': {
                display: 'none !important'
              }
              // overflowX: 'hidden'
            }
          }
        }
      }
    }
  },

  '@keyframes Gradient': {
    '0%': {
      backgroundPosition: '0% 50%'
    },
    '50%': {
      backgroundPosition: '100% 50%'
    },
    '100%': {
      backgroundPosition: '0% 50%'
    }
  },
  '.sk-spinner': {
    transform: 'scale(.73)'
  }
};

export default style;

// NOTE: put overrides, animations, and default root styles in here
